// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","911":"component---src-pages-search-tsx"}[chunkId] || chunkId) + "-" + {"245":"a50bb71021d0d51d4b2f","453":"7f0d537808db8b33ad4f","454":"b5c626670e2e4db210f2","911":"81cd5cec74ba69c82af4"}[chunkId] + ".js";
};